module.exports = __webpack_public_path__ + "static/img/Bachelor_010261.f7467a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010261.jpg
// module id = 132
// module chunks = 0